import { formatDateLocal } from "../../../lib/script";
import BodySimpleModalV3 from "../../common/modal/BodySimpleModalV3";
import Tag from "../../fragments/Tag";

export default function ReturningPatient({caseData}) {

    // const caseData = {
    //     return_for_treatment: true,
    //     return_for_treatment_date: '2025-01-01'
    // }
    return <>
        {(caseData && caseData.return_for_treatment && caseData.return_for_treatment_date)? <>
            <BodySimpleModalV3 message={`Return to Tx. on ${formatDateLocal(caseData.return_for_treatment_date)}`}>
                <Tag>Return to Tx.</Tag>
            </BodySimpleModalV3>
        </> : null}
    </>
}